/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import Tabla from '@infotrack/presentacion-componentes/tabla';
import React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { ITablaClasificacionesVistaProps } from '../interfaces';
import { acciones, columnas, opciones } from './constantes';

const VistaClasificaciones: React.FunctionComponent<ITablaClasificacionesVistaProps & InjectedIntlProps> = ({
    clasificacioness,
    cargarClasificaciones,
    confirmarEliminacion,
    intl,
    manejarFormulario,
}) => (
    <div>
        <Tabla
            columns={columnas(intl.formatMessage)}
            data={clasificacioness}
            actions={acciones(manejarFormulario, cargarClasificaciones, intl.formatMessage, confirmarEliminacion)}
            options={opciones}
        />
    </div>
);

export default injectIntl(VistaClasificaciones);
